import React from 'react';

const palette = {
  background: {
    default: '#FBF9F9',
    deep: '#dce0e9',
  },
  button: {
    default: '#e5e5ed',
    primary: '#6161e6',
    change: '#C8C8D9',
    dark: '#353339',
    transparent: '#ffffff',
    light: '#f2f2f7',
    excel: '#98dcb4',
  },
  buttonText: {
    default: '#6b6d6b',
    primary: '#f5f5f5',
    change: '#353541',
    dark: '#f5f5f5',
    transparent: '#333333',
    light: '#353541',
    excel: '#6b6d6b',
    blue: '#0d6efd',
  },
  buttonHover: {
    default: '#cac9da',
    primary: '#9191d6',
    change: '#9998a5',
    dark: '#585770',
    transparent: '#f5f2f9',
    light: '#e1e1ec',
    excel: '#79a78a',
  },
  appBar: {
    default: '#353339',
    reverse: '#f5f5f5',
  },
  appBarText: {
    default: '#f5f5f5',
    reverse: '#353339',
  },
  textfield: {
    default: '#7e7d98',
    primary: '#ebebeb',
  },
  textfieldText: {
    default: '#aaaaaa',
  },
  text: {
    default: '#4B5464',
    dark: '#000000',
  },
  border: {
    default: '#DADEE0',
  },
  icon: {
    default: '#4B5464',
    primary: '#eba300',
    dark: '#595770',
  },
};

export default palette;
